<template>
	<Form ref="formValidate" :model="formValidate"  :label-width="110":label-colon="true">
		<Row>
			
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="用户ID" :label-width="80">
				<Input v-model="formValidate.id" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="首次登录日期" prop="dateRange">
				<DatePicker type="daterange" v-model="formValidate.dateRange" :options="dateRangeOptions"
					format="yyyy/MM/dd" placement="bottom-end" placeholder="请选择" clearable/>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="APP">
				<Select v-model="formValidate.channel" clearable>
					<Option value="1">兼职直聘</Option>
					<Option value="2">应届生直聘</Option>
					<Option value="3">线上日结宅家赚</Option>
					<Option value="4">蜗牛兼职</Option>
					<Option value="5">小金豆</Option>
					<Option value="6">大熊兼职商家版</Option>
					<Option value="7">大熊兼职</Option>
					<Option value="8">米罐兼职</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="10" :sm="12" :xs="24">
			<FormItem>
				<Button type="primary" @click="formSubmit" icon="md-search"style="margin: 0 8px 16px 16px;">查询</Button>
				<Button type="default" @click="formReset" style="margin: 0 8px 16px 16px;">重置</Button>
			</FormItem>
			</Col>
		</Row>
	</Form>
</template>
<script>
	import api from '../../api'
	import { mapGetters } from 'vuex'
	import { STATISTICS_START_TIME, LINK_TYPES, ADVERT_TYPES } from '../../config/constants'

	export default {
		name: 'QueryCondition',
		props: {

		},
		data() {
			return {
				
				formValidate: {
					id:undefined,
					channel:undefined,
					dateRange: [],
				},
				dateRangeOptions: {
					//当前日期之后日期为禁选日期
					disabledDate(date) {
						const startDate = new Date(STATISTICS_START_TIME).getTime()
						const now = Date.now()
						return (
							date && !(date.valueOf() >= startDate && date.valueOf() <= now)
						)
					}
				}
			}
		},

		methods: {
			
			formSubmit() {
				this.$emit('query', this.getFormData())
			},
			
			formReset() {
				this.$refs['formValidate'].resetFields()
				this.formValidate = {
					dateRange: [],
				}
				this.formSubmit()
			},
			getFormData() {
				let beginTime = this.formValidate.dateRange[0] || null
				let endTime = this.formValidate.dateRange[1] || null
				const formData = {
					beginTime: beginTime ? this.util.formatDateTime(beginTime) : null,
					endTime: endTime ? this.util.dateFormat(endTime, 'yyyy-MM-dd') + ' 23:59:59' : null,
					id:this.formValidate.id,
					channel:this.formValidate.channel
				}
				return formData
			}
		}
	}
</script>
